import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import React, { FunctionComponent, useMemo } from 'react';
import { useCheckoutCourseLink } from '../../useCheckoutCourseLink';
import { ShareLinks } from '../../../ShareLinks';

type CourseShareLinksProps = {
    course: PublicCourse;
    educatorFeatureFlags?: PublicEducator['feature_flags'];
};

export const CourseShareLinks: FunctionComponent<CourseShareLinksProps> = ({
    course,
    educatorFeatureFlags,
}) => {
    const courseLink = useCheckoutCourseLink();

    const shareText: string = useMemo((): string => {
        return encodeURIComponent(
            `I just ${course && course.name ? ` booked this ${course.name} course with ${course.educator.name}.` : ' booked a course on Cademy.'} Check it out:`
        );
    }, [course]);

    const shareLink: string = useMemo((): string => {
        if (course) return encodeURIComponent(courseLink);
        return encodeURIComponent(`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}`);
    }, [course, courseLink]);

    if (educatorFeatureFlags?.hide_social_prompts) return null;

    return (
        <ShareLinks
            shareText={shareText}
            shareLink={shareLink}
            educatorFeatureFlags={educatorFeatureFlags}
        />
    );
};
